import { useMutation } from '@tanstack/react-query'
import { api } from '@api'
import { secureTokenStore } from '@store'
import * as RNLocalize from 'react-native-localize'

interface Account {
  id: string
  email: string
  isOnboardingCompleted: boolean
}

export interface SignUpResponse {
  account: Account
  accessToken: string
  refreshToken: string
}

interface SignUpCredentials {
  email: string
  password: string
}

const getDeviceLanguage = (): string => {
  try {
    const lang = RNLocalize.getLocales()[0].languageTag.split('-')[0]
    return ['en', 'fr', 'es'].includes(lang) ? lang : 'fr'
  } catch {
    return 'fr'
  }
}

const signUp = async (credentials: SignUpCredentials): Promise<SignUpResponse> => {
    const language = getDeviceLanguage()
    const { data } = await api.post<SignUpResponse>('/v2/authentication/accounts', { ...credentials, language })

    if (data.accessToken && data.refreshToken) {
      await secureTokenStore.setTokens(data.accessToken, data.refreshToken)
    }

    const { password: _password, ...sanitizedAccount } = data.account as Account & { password?: string }

    return {
      ...data,
      account: sanitizedAccount,
    }
}

export const useSignUp = () => {
  return useMutation<SignUpResponse, Error, SignUpCredentials>({
    mutationFn: signUp,
  })
}
